export default __webpack_public_path__ + "static/media/avatar3.4f9f4577.png";